import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const AttachmentIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575c',
  fill = 'none',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21.44 11.05-9.19 9.19a6.004 6.004 0 0 1-8.49-8.49l9.19-9.19a4.002 4.002 0 1 1 5.66 5.66l-9.2 9.19a2.001 2.001 0 1 1-2.83-2.83l8.49-8.48"
    />
  </svg>
);
